export const ItemDetailStandardActionsComponent = {
  templateUrl:
    './app/ajs/_shared/components/item-detail-standard-actions/item-detail-standard-actions.component.html',
  bindings: {
    viewMode: '<',
    createMode: '<',
    editItem: '&',
    editItemShow: '<',
    editItemDisabled: '<',
    saveItem: '&',
    saveItemShow: '<',
    saveItemDisabled: '<',
    saveItemLabel: '@',
    updateItemLabel: '@',
    cancel: '&',
    sendingForm: '<',
    buttonsClass: '@',
    isModal: '<',
  },
  controller: function () {},
  controllerAs: 'vm',
};
